import ApiService from "@/core/services/ApiService";

class AccountService {

    public static getSetting(){
        ApiService.setHeader()
        return ApiService.get('api/accounts', 'setting')
    }

    public static getData(params) {
        ApiService.setHeader()
        return ApiService.post('api/accounts',params)
    }

    public static update (id, target, data) {
        ApiService.setHeader()
        return ApiService.put(`api/accounts/${id}/${target}`,data)
    }

    public static delete(id: string) {
        ApiService.setHeader()
        return ApiService.delete(`api/accounts/${id}`, 'delete')
    }

    public static getOptions(resource, slug){
        ApiService.setHeader()
        return ApiService.get(resource, slug)
    }

    public static postOptions(resource: string, params: any){
        ApiService.setHeader()
        return ApiService.post(`api/accounts/${resource}`, params)
    }
}

export default AccountService;